<template>
    <div>
        <h3 class="mb-1">Rekapitulacija po DDV stopnjah</h3>
        <div class="overflow-auto">
            <table class="w-100 overflow-auto">
                <thead>
                    <tr>
                        <th>DDV</th>
                        <th>Stopnja (%)</th>
                        <th>Osnova za DDV (€)</th>
                        <th>Znesek za DDV (€)</th>
                        <th>Skupaj (€)</th>
                    </tr>
                </thead>
                <tbody v-if="data && data.rekapitulacija_ddv && data.rekapitulacija_ddv.stroski.length > 0">
                    <tr v-for="(item, index) of data.rekapitulacija_ddv.stroski" :key="`vat_${index}`">
                        <td>{{ item.davcna_stopnja_naziv }}</td>
                        <td>{{ convertFloat(item.davcna_stopnja_procent) }}</td>
                        <td>{{ convertFloat(item.osnova_ddv, 4) }}</td>
                        <td>{{ convertFloat(item.znesek_ddv, 4) }}</td>
                        <td>{{ convertFloat(item.skupaj_zddv, 4) }}</td>
                    </tr>
                    <tr :class="{'colored': !hasPSorRS}">
                        <th>
                            Skupaj stroški
                        </th>
                        <th/>
                        <th>
                            {{ convertFloat(data.rekapitulacija_ddv.stroski.reduce((x, y) => {return x + y.osnova_ddv},0), 4) }}
                        </th>
                        <th>
                            {{ convertFloat(data.rekapitulacija_ddv.stroski.reduce((x, y) => {return x + y.znesek_ddv},0), 4) }}
                        </th>
                        <th>
                            {{ convertFloat(data.rekapitulacija_ddv.stroski.reduce((x, y) => {return x + y.skupaj_zddv},0), 4) }}
                        </th>
                    </tr>
                    <tr v-if="data.rekapitulacija_ddv.poraba_ps">
                        <th class="border-t">
                            Skupaj poraba prostovoljno zbranih sredstev
                        </th>
                        <th class="border-t"/>
                        <th class="border-t"/>
                        <th class="border-t"/>
                        <th class="border-t">
                            {{ convertFloat(data.rekapitulacija_ddv.poraba_ps, 4) }}
                        </th>
                    </tr>
                    <tr v-if="data.za_placilo.poraba_rezervega_sklada_skupaj_zddv !== 0">
                        <th class="border-t">
                            Skupaj poraba rezervnega sklada
                        </th>
                        <th class="border-t"/>
                        <th class="border-t"/>
                        <th class="border-t"/>
                        <th class="border-t">
                            {{ convertFloat(data.za_placilo.poraba_rezervega_sklada_skupaj_zddv, 4) }}
                        </th>
                    </tr>
                    <tr v-if="hasPSorRS" class="colored">
                        <th class="border-t">
                            Vse skupaj
                        </th>
                        <th class="border-t"/>
                        <th class="border-t"/>
                        <th class="border-t"/>
                        <th class="border-t">
                            {{ convertFloat(data.rekapitulacija_ddv.stroski.reduce((x, y) => {return x + y.skupaj_zddv},0) + data.rekapitulacija_ddv.poraba_ps + data.za_placilo.poraba_rezervega_sklada_skupaj_zddv, 4) }}
                        </th>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="5" class="text-center">
                            Ni podatkov za prikaz
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {convertFloat} from '@/libs/helpers'

    export default {
        methods: {convertFloat},
        props: {
            data: {
                type: Object,
                default: undefined
            }
        },
        computed: {
            hasPSorRS() {
                return this.data && (this.data.rekapitulacija_ddv.poraba_ps || this.data.rekapitulacija_ddv.poraba_rs)
            }
        }
    }
</script>